module.exports = __webpack_public_path__ + "img/1-2.c5bc0ea2.png";